import React from 'react';
import { Card, Table, Tag, Typography } from 'antd';
import { getSmsHistoryColumns, getEmailHistoryColumns } from './tableColumns';

const { Text } = Typography;

interface HistoryViewProps {
  type: 'sms' | 'email';
  data: any;
  loading: boolean;
}

const HistoryView: React.FC<HistoryViewProps> = ({ type, data, loading }) => {
  if (loading) {
    return (
      <div
        style={{
          padding: '60px 0',
          textAlign: 'center',
          fontSize: '16px',
          color: '#666',
        }}
      >
        <div style={{ fontSize: '24px', marginBottom: '16px' }}>⏳</div>
        Loading send history...
      </div>
    );
  }

  const records = data?.data?.records || [];
  const columns = type === 'sms' ? getSmsHistoryColumns() : getEmailHistoryColumns();
  const title = type === 'sms' ? '📱 SMS History' : '📧 Email History';
  const color = type === 'sms' ? 'green' : 'blue';
  const borderColor = type === 'sms' ? '#f6ffed' : '#e8f4fd';

  if (records.length === 0) {
    return (
      <div
        style={{
          padding: '60px 20px',
          textAlign: 'center',
          backgroundColor: '#fafafa',
          borderRadius: '8px',
          border: '1px solid #f0f0f0',
        }}
      >
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📭</div>
        <Text type="secondary" style={{ fontSize: '16px', fontWeight: '500' }}>
          No {type === 'sms' ? 'SMS' : 'Email'} history found.
        </Text>
      </div>
    );
  }

  return (
    <Card
      title={
        <div
          style={{
            fontSize: '16px',
            fontWeight: '600',
            color: type === 'sms' ? '#52c41a' : '#1890ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {title}
            <Tag color={color} style={{ fontSize: '12px' }}>
              {records.length} records
            </Tag>
          </div>
          <div
            style={{
              fontSize: '12px',
              color: '#666',
              fontWeight: 'normal',
            }}
          >
            Last updated:{' '}
            {new Date().toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            })}
          </div>
        </div>
      }
      style={{
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: `1px solid ${borderColor}`,
      }}
    >
      <div style={{ marginTop: '-16px' }}>
        <Table
          className="send-note-table"
          columns={columns}
          dataSource={records}
          rowKey="id"
          pagination={{
            pageSize: 10,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
            size: 'small',
          }}
          scroll={{ x: type === 'sms' ? 580 : 700, y: 420 }}
          size="middle"
          style={{
            fontSize: '13px',
            backgroundColor: '#fafafa',
            marginTop: 0,
          }}
          rowClassName={(record, index) =>
            index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
          }
        />
      </div>
    </Card>
  );
};

export default HistoryView;

